export const PERFORMANCE_LAB_BOOK_TOUR_TYPEFORM_SESSION_KEY =
  'uh_performance_lab_book_tour_typeform_shown';

export const PERFORMANCE_LAB_BOOK_TOUR_AUTO_DELAY_MS = 7000;

export const PL_BOOK_TOUR_SCROLL_ANCHOR_ATTR = 'book-tour-scroll-anchor';

export const PL_BOOK_TOUR_SCROLL_ANCHOR_SELECTOR = `[data-pl-section="${PL_BOOK_TOUR_SCROLL_ANCHOR_ATTR}"]`;

export const markPerformanceLabBookTourTypeformShown = (): void => {
  try {
    sessionStorage.setItem(PERFORMANCE_LAB_BOOK_TOUR_TYPEFORM_SESSION_KEY, '1');
  } catch {
    // sessionStorage unavailable (SSR / privacy mode)
  }
};

export const hasPerformanceLabBookTourTypeformBeenShown = (): boolean => {
  try {
    return (
      sessionStorage.getItem(PERFORMANCE_LAB_BOOK_TOUR_TYPEFORM_SESSION_KEY) ===
      '1'
    );
  } catch {
    return false;
  }
};
